import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { CircularProgress, Backdrop as MaterialBackdrop, Typography } from '@mui/material';

const MESSAGE_INTERVAL_MS = 3000;

const StyledBackdrop = styled(MaterialBackdrop)`
  z-index: 1000;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

/**
 * Full-page loading overlay with a centered spinner. Mount it at the end of a
 * page and drive it with the route's fetching state. Pass an optional message
 * to tell the user what is in progress; pass an array of messages to advance
 * through them every few seconds, stopping on the last one.
 */
const Backdrop = ({ isOpen, message }) => {
  const messages = [].concat(message);
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!isOpen || messages.length <= 1) {
      return undefined;
    }

    setMessageIndex(0);
    const interval = setInterval(
      () => setMessageIndex(index => Math.min(index + 1, messages.length - 1)),
      MESSAGE_INTERVAL_MS
    );

    return () => clearInterval(interval);
  }, [isOpen, messages.length]);

  return (
    <StyledBackdrop open={isOpen}>
      <ContentWrapper>
        <CircularProgress color="inherit" />
        {messages[messageIndex] && (
          <Typography color="inherit">{messages[messageIndex]}</Typography>
        )}
      </ContentWrapper>
    </StyledBackdrop>
  );
};

Backdrop.defaultProps = {
  message: '',
};

Backdrop.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default Backdrop;
